import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'ADMIN_UPDATE',
    smsDelete : 'ADMIN_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        admin: [],
        adminDetails: null,
        submitSuccess: false,
        adminLoading: false,
        adminError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_ADMIN(state, admin) {
            state.admin = admin;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        ADMIN_LOADING (state, loading) {
            state.adminLoading = loading;
        },

        ADMIN_ERROR (state, hasError) {
            state.adminError = hasError;
        }
    },

    actions: {
        async updatePassword ({commit, dispatch}, payload) {
            commit('ADMIN_LOADING', true);
            commit('ADMIN_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.change_password, payload, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                return response

            } catch (e) {
                commit('ADMIN_ERROR', true);
            } finally {
                commit('ADMIN_LOADING', false);
            }
        },

        async addAdmin ({commit, dispatch}, payload) {
            commit('ADMIN_LOADING', true);
            commit('ADMIN_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_admin, payload, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchAdmin')
                return response

            } catch (e) {
                commit('ADMIN_ERROR', true);
            } finally {
                commit('ADMIN_LOADING', false);
            }
        },

        async fetchAdmin ({ commit }) {
            commit('ADMIN_LOADING', true);
            commit('ADMIN_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let result = await axios.get(V1API.admin_list, config);
                let response = result.data
                commit('SET_ADMIN', response.data);

            } catch(error) {
                commit('ADMIN_ERROR', true);
            } finally {
                commit('ADMIN_LOADING', false);
            }
        },

        // async updateAdmin ({commit, dispatch}, payload) {
        //     let config = {
        //         headers: {
        //             Authorization: "Bearer " + localStorage.getItem("access_token"),
        //         }
        //     };

        //     try {
        //         let response = await axios.patch(V1API.update_admin + payload.id, payload.admin, config).then(result=>{
        //             let data = result.data
        //             return data
        //         });

        //         commit('SUBMIT_SUCCESS', true);
        //         dispatch ('fetchAdmin')
        //         return response

        //     } catch (e) {
        //         commit('ADMIN_ERROR', true);
        //     } finally {
        //         commit('ADMIN_LOADING', false);
        //     }
        // },
        
        async deleteAdmin({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.admin_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchAdmin')
            return response
        }
    },

    getters: {}
}
